import api from "../../Http/global-vars";

export const getData = async (url, token) => {
  const path = url.endsWith('/') ? url : url + '/';
  const res = await fetch(`${api}${path}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json();
  return data;
};

export const fetchData = async (url) => {
  const path = url.endsWith('/') ? url : url + '/';
  const res = await fetch(`${api}${path}`, {
    method: "GET",
  });

  const data = await res.json();
  return data;
};

export const getDataByID = async (url, id, token) => {
  const res = await fetch(`${api}${url}/${id}/`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json();
  return data;
};

export const postData = async (url, post, token) => {
  // console.log('url', api)
  const path = url.endsWith('/') ? url : url + '/';
  const res = await fetch(`${api}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(post),
  });

  const data = await res.json();
  return data;
};

export const putData = async (url, post, token) => {
  const path = url.endsWith('/') ? url : url + '/';
  const res = await fetch(`${api}${path}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(post),
  });

  const data = await res.json();
  return data;
};

export const patchData = async (url, post, token) => {
  const path = url.endsWith('/') ? url : url + '/';
  const res = await fetch(`${api}${path}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(post),
  });

  const data = await res.json();
  return data;
};

export const deleteData = async (url, token) => {
  const path = url.endsWith('/') ? url : url + '/';
  const res = await fetch(`${api}${path}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const data = await { success: "Success" };
  return data;
};
